/**
 * Utility functions
 */


var moment = require('moment')
var _ = require('lodash')

_.templateSettings.variable = 'vars'
/**
 * Generate Google calender link from an upcoming broadcast.
 * @param  {[type]}
 *  broadcast [description]
 * @param  {[type]} context   [description]
 * @return {[type]}           [description]
 */
function generateGoogleCalLink(broadcast, church) {
  let baseUrl = 'https://venue.streamspot.com/';
  if (window.location.hostname.includes('testing') || window.location.hostname.includes('stage') || window.location.hostname.includes('sandbox') || window.location.hostname.includes('localhost')) {
    baseUrl = 'https://testing-venue.streamspot.com/';
  }
  var compiled = _.template('https://www.google.com/calendar/render?action=TEMPLATE&text=<%= vars.title %>&dates=<%= vars.calStart %>/<%= vars.calEnd %>&details=<%= vars.details %>&location='+ baseUrl + church.idHash + '&ctz=' + church.timezoneSet + '&sf=true&uid&pli=1&output=xml')
  var broadcastClone = _.clone(broadcast)
  broadcastClone.calStart = moment(broadcast.start).format('YYYYMMDD\\THHmm00')
  broadcastClone.calEnd = moment(broadcast.end).format('YYYYMMDD\\THHmm00')
  broadcastClone.details = 'Live Broadcast reminder for ' + church.name + ', powered by StreamSpot'
  if (!broadcastClone.title) {
    broadcastClone.noTitle = true
    broadcastClone.title = broadcast.startTime
  }
  broadcastClone.title = 'Live: ' + church.name + ' - ' + broadcast.title
  return compiled(broadcastClone)
}

/**
 * Determines player type
 * @param  {[type]} qs [description]
 * @return {[type]}    [description]
 */
function determinePlayerType(qs){
  if (qs['cn']) {
    if (qs['category']) {
      return 'category'
    }
    return 'church'
  }
  if (qs['eventId']) {
    return 'event'
  }
  if (qs['idHash']) {
    if (qs['category']) {
      return 'category'
    }
    return 'church'
  }
  if (qs['video']) {
    return 'video'
  }
  if (qs['playerId'] || qs['p']) {
    return 'player'
  }
  return false
}

var entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  '\'': '&#39;',
  '/': '&#x2F;'
}

/**
 * Escape Html function
 * @param  {[type]} string [description]
 * @return {[type]}        [description]
 */
function escapeHtml(string) {
  return String(string).replace(/[&<>"'\/]/g, function(s) {
    return entityMap[s]
  })
}

function supportMediaQuery(){
  let answer = false
  const d = document.createElement('div')
  d.className = 'mediatest'
  document.body.appendChild(d)
  if( window.getComputedStyle && window.getComputedStyle(d).position == 'absolute') {
    answer = true
  }
  document.body.removeChild(d)
  return answer
}

/**
 * Get all the GET params as an object
 * @param  {[type]} window [description]
 * @return {[type]}        [description]
 */
function qs(window){
  return (function(a) {
    if (a == '') return {}
    var b = {}
    for (var i = 0; i < a.length; ++i) {
      var p = a[i].split('=', 2)
      if (p.length == 1)
        b[p[0]] = ''
      else
        b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, ' '))
    }
    return b
  })(window.location.search.substr(1).split('&'))
}

var util = {
  generateGoogleCalLink: generateGoogleCalLink,
  determinePlayerType: determinePlayerType,
  escapeHtml: escapeHtml,
  qs: qs,
  supportMediaQuery: supportMediaQuery
}
window.util = util
module.exports = util



// WEBPACK FOOTER //
// ./src/util.js